import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { AuditModel } from 'modules/employees/audit-logs/types';

export const getEmployeeeAuditLogsRequest = async (employeeId: number, companyId: number): Promise<AuditModel[]> => {
  const response: AxiosResponse<AuditModel[]> = await getApi().get(`audit/getEmployeeLogs/${companyId}/${employeeId}`);
  return response.data;
};
